"use client";

import { Suspense } from "react";
import { VisitorTracker } from "@/components/analytics/VisitorTracker";

/** Suspense boundary required because VisitorTracker uses useSearchParams. */
export function VisitorTrackerLoader() {
  return (
    <Suspense fallback={null}>
      <VisitorTracker />
    </Suspense>
  );
}
